import React from 'react';
import {Link} from "react-router-dom";
import '../styles/_404.css';
import '../styles/Global.css';

export default function _404() {
    return (
        <div className="about-frame">
            <div id="about">
                <p>404 - YEAH, THIS DOESN'T PAGE EXIST.</p>
            </div>
            <div className="everything-container">
                <span className="normal-text">
                    "what the heck, skye? why am i here?"
                <br/><br/>
                    well, you somehow got to a part of our website that doesn't exist, or it's OBSCURED. TOP-SECRET.

                <br/><br/>
                    actually, if i tell you what's behind this part of the page, i'd have to kill you.

                </span>


            <Link to="/"><button className="fof-menu-button"><span>GO HOME BRUH 😭😭</span></button></Link>
            </div>
        </div>
    );
}